import { createFileRoute } from '@tanstack/react-router'
import { AdminMarketingOverview } from '@/components/admin/marketing/AdminMarketingOverview'

export const Route = createFileRoute('/admin/marketing/overview')({
  component: () => <AdminMarketingOverview />,
})
